module.exports = __webpack_public_path__ + "img/amazonas.aff7081e.png";